import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';

export const clinicPractitionerUserIdsQueryKey = (clinicId: string | null) =>
  ['clinic-practitioner-user-ids', clinicId] as const;

/** Practitioner-flagged user ids. Patients can call this for course booking. */
export function useClinicPractitionerUserIds(clinicId: string | null | undefined, enabled = true) {
  return useQuery({
    queryKey: clinicPractitionerUserIdsQueryKey(clinicId ?? null),
    enabled: Boolean(clinicId) && enabled,
    queryFn: async (): Promise<string[]> => {
      if (!clinicId) return [];
      const { data, error } = await supabase.rpc(
        'clinic_practitioner_user_ids' as never,
        { p_clinic_id: clinicId } as never,
      );
      if (error) throw error;
      return (data ?? []) as string[];
    },
  });
}
